define([
], function(
    ){
    /**
     * @exports views/diagram/menu/menu-icon
     */
    var MenuIcon = {
        /**
         * font awesome のアイコンを描画するための関数
         *
         * @param faclass {String} - font awesome のアイコンクラス名 e.g.) 'fa fa-cross'
         * @param opts {Object}
         * @param opts.scale {float} - 縮尺のスケール default 0.6
         * @param opts.color {String} - 色
         * @returns {Function}
         */
        fontAwesomeIcon: function(faclass, opts) {
            opts = _.extend({
                scale: 0.6,
                color: 'black'
            }, opts);

            return function(svg, size) {
                svg.append('g')
                    .classed('menu-item-icon theme-menu-item-icon', true)
                    .append('foreignObject')
                    .attr('width', size.width)
                    .attr('height', size.height)
                    .attr('transform', function(){
                        return 'translate(' + - size.width/2 + ',' + - size.height/2 + ')';
                    })
                    .append('xhtml:div')
                    .style('height', size.height)
                    .style('text-align', 'center')
                    .style('vertical-align', 'middle')
                    .style('line-height', size.height + 'px')
                    .style('font-size', size.height * opts.scale + 'px')
                    .style('color', opts.color)
                    .append('xhtml:i')
                    .attr('class', faclass)
            }
        },

        /**
         * SVG エレメントを描画するための関数
         *
         * shape は render メソッドと width プロパティを持っている必要がある
         *
         * @param shape {Object} - 描画される SVG エレメントのクラス
         * @returns {Function}
         */
        shapeIcon: function(shape) {
            return function(svg, size){
                var scale = size.width / Math.max(
                    shape.height(), shape.width()) * 0.5;
                var g = svg.append('g')
                    .classed('menu-item-shape theme-menu-item-shape', true);
                g.append(shape.render().el);
                g.attr('transform', function() {
                    return 'scale(' + scale + ')';
                })
            }
        }
    }

    return MenuIcon;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/menu/icon.js